/**
 * Used to calculated the total sum per column of the time section type report
 */
export function formatTimeSectionData({ rawData = [] } = {}) {
  const totalData = {
    tramo: "Total",
    recibidas: 0,
    atendidas: 0,
    atendidas_ns: 0,
    abandonadas: 0,
    nivel_atencion: 0,
    nivel_servicio: 0,
    nivel_abandono: 0,
    tmo: 0,
    tme: 0,
    tiempo_hablado: 0,
    tiempo_tipificado: 0,
    sum: 0,
  };

  for (const row of rawData) {
    totalData.recibidas += row.recibidas;
    totalData.atendidas += row.atendidas;
    totalData.atendidas_ns += row.atendidas_ns;
    totalData.abandonadas += row.abandonadas;
    totalData.tmo += row.tmo;
    totalData.tme += row.tme;
    totalData.tiempo_hablado += row.tiempo_hablado;
    totalData.tiempo_tipificado += row.tiempo_tipificado;
    totalData.sum += row.sum;
  }

  totalData.nivel_atencion = (totalData.atendidas / totalData.recibidas).toFixed(2);
  totalData.nivel_servicio = (totalData.atendidas_ns / totalData.recibidas).toFixed(2);
  totalData.nivel_abandono = (totalData.abandonadas / totalData.recibidas).toFixed(2);

  return [...rawData, totalData];
}
